import { Typography } from "@/components";
import useBulletinMutation from "@/hooks/useBulletinMutation";
import type { BulletinGroup } from "@/types";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { toast } from "sonner";

interface DrawerRemoveGroupProps {
	group?: BulletinGroup | null;
	groupSubscriptions: BulletinGroup[];
	onClickClose: () => void;
}

const DrawerRemoveGroup = (props: DrawerRemoveGroupProps) => {
	const { group, groupSubscriptions, onClickClose } = props;
	const { subscribe } = useBulletinMutation();

	if (!group) return null;

	const onClickRemove = async (e: React.MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		try {
			const removedGroups = groupSubscriptions.filter(
				(subscription) => subscription.id !== group.id,
			);
			if (!removedGroups.length) return onClickClose();
			await subscribe.mutateAsync(removedGroups.map((group) => group.id));
			return onClickClose();
		} catch (error) {
			toast.error("Failed to remove group from bulletin tab");
		}
	};
	return (
		<div className="relative h-fit w-screen bg-white flex flex-col py-4">
			<div className="wrapper space-y-4">
				<div className="container flex flex-col gap-4">
					<Typography fontWeight={700} fontSize={16}>
						Remove Bulletin Tab
					</Typography>
					<Typography fontWeight={400} fontSize={14}>
						Remove "{group.name}" from your bulletin tabs?
					</Typography>
				</div>
				<Divider />
				<div className="grid grid-cols-2 gap-4 justify-center items-center">
					<Button
						type="button"
						variant="outlined"
						color="primary"
						size="large"
						className="!rounded-full"
						onClick={onClickClose}
					>
						Cancel
					</Button>
					<Button
						type="button"
						variant="contained"
						color="error"
						size="large"
						className="!rounded-full"
						onClick={onClickRemove}
					>
						Remove
					</Button>
				</div>
			</div>
		</div>
	);
};

export default DrawerRemoveGroup;
